import features from '../common/features';

export default function detectCompanionSeat(seat) {
  let holdCodes = features.getOption('companionSeats', 'holdCodes');
  let seatTypes = features.getOption('companionSeats', 'seatTypeIds');

  return holdCodes.includes(seat.hc_no) || seatTypes.includes(seat.seat_type);
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/detectCompanionSeat.js